import setLayers from "./setLayers"
import setViewport from "./setViewport";

const updateMapByDirectory = (map, directory) => {
    setLayers(map, directory);
    setViewport(map, directory);
}

export default updateMapByDirectory;